"use client";

import { ReactNode } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "stores/store";
import SendbirdProvider from "./sendbird/SendBirdProvider";
type ProviderProps = {
  children: ReactNode;
};
const Providers = (props: ProviderProps) => {
  const {
    children
  } = props;
  return <ReduxProvider store={store} data-sentry-element="ReduxProvider" data-sentry-component="Providers" data-sentry-source-file="providers.tsx">
      <SendbirdProvider data-sentry-element="SendbirdProvider" data-sentry-source-file="providers.tsx">{children}</SendbirdProvider>
    </ReduxProvider>;
};
export default Providers;